import React from 'react';
import styles from './formLabel.module.scss';
import classnames from 'classnames';

export interface FormLabelProps {
  label: string;
  error?: string | undefined | null;
  required: boolean | undefined;
  className?: string;
}

const FormLabel = ({ label, error, required, className }: FormLabelProps) => (
  <label className={classnames(styles.root, className || '')}>
    {label}
    {required ? <span className={styles.redAsterisk}>*</span> : null}
    {error && <span className={styles.errorMsg}>{error}</span>}
  </label>
);

export default FormLabel;
